import { StatusCodes } from 'http-status-codes';

export default function() {
    return {
        beforeSend(event, hint) {
            const error = hint.originalException;
            const status = error?.response?.status;

            if (
                status &&
                status >= StatusCodes.BAD_REQUEST &&
                status < StatusCodes.INTERNAL_SERVER_ERROR
            ) {
                return null;
            }

            return event;
        }
    };
}
